import Vue from "vue";
import moment from "moment-timezone";
import * as Cookies from "js-cookie";

Vue.mixin({
  data() {
    return {
      ROOMSIZE: [25, 50, 75, 100, 125, 150, 175, 200],
      DURATION_HOURS: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      DURATION_MINS: [0, 15, 30, 45],
      tagsOnKeys: [9, 13, 32],

      GUEST: 0,
      USER: 1,
      TRAINER: 2,
      ADMIN: 3,

      SESSION: 1, // || ENTITY TYPE
      COURSE: 2, // || ENTITY TYPE

      HOME: 'home',
      USERSESSIONDETAILS: 'UserSessionDetails',
      USERCOURSEDETAILS: 'UserCourseDetails',
      USERSESSIONLIVE: 'UserSessionLive',

      TRAINERSESSIONLIVE: "TrainerSessionLive",

      USERROUTES: ['UserSessionDetails', 'UserCourseDetails'],
      TRAINERROUTES: ['TrainerSessionLive'],

      STATUS_FALSE: 0, // entity if deleted
      STATUS_TRUE: 1, // session has been scheduled by trainer
      STATUS_STARTED: 2, // session is live and launched by trainer (show slot status as LIVE on session detail page)
      STATUS_COMPLETED: 3, // session is ended by trainer and has been completed (show slot status is END on user session detail page)

      DETAILS: 'details',
      VUE_APP_APP_URL: window && window.config && window.config.VUE_APP_APP_URL,
      VUE_APP_ZOOMOAUTH_CLIENT_ID: window && window.config && window.config.VUE_APP_ZOOMOAUTH_CLIENT_ID,
    };
  },
  methods: {
    handleStr(str, n) {
      return str && str.length > n ? str.substr(0, n - 1) + "..." : str;
    },

    hourToMinConverter(data) {
      var hours = data / 60;
      var rhours = Math.floor(hours);
      var minutes = Math.round((hours - rhours) * 60);
      if (minutes == 0) {
        minutes = minutes.toString() + "0";
      }
      var time = rhours.toString() + ":" + minutes.toString();
      return time;
    },

    handleUserName(str) {
      return "@" + str.split(" ")[0];
    },

    convertUTCDateToLocalDate(dateVal, currentTimeZone) {
      var date = moment(dateVal).format("YYYY-MM-DDTHH:mm:ss");
      // var date = dateVal.replace(/\s/, 'T');
      date = this.formatDateTime(date);
      date = new Date(date);
      // var localOffset = date.getTimezoneOffset() * 60000;
      // var localTime = date.getTime();
      // date = localTime - localOffset;
      date.toLocaleString('en-us', { timeZone: currentTimeZone || this.getTimeZone() })
      return this.formatDateTime(new Date(date));
    },

    utcToLocalWithFormat(date, slice = true, currentTimeZone) {
      date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
      date = new Date(date);
      // var localOffset = date.getTimezoneOffset() * 60000;
      // var localTime = date.getTime();
      // date = localTime - localOffset;
      // date = moment(date).format
      date.toLocaleString('en-us', { timeZone: currentTimeZone || this.getTimeZone() })
      date = moment(new Date(date)).format("YYYY-MM-DDTHH:mm:ss");
      if (slice) {
        if ((date + "").slice(-8) == '00:00:00') {
          return '23:59:00'
        } else {
          return (date + "").slice(-8)
        }
      }
      return date + "";
    },

    convertLocalDateToUTCDate(now, currentTimeZone) {
      now = moment(now).format("YYYY-MM-DDTHH:mm:ss");
      var userdate = new Date(now);
      // var timezone = userdate.getTimezoneOffset();
      // var serverdate = new Date(
      //   userdate.setMinutes(userdate.getMinutes() + parseInt(timezone))
      // );
      var serverdate = userdate.toLocaleString('en-us', { timeZone: currentTimeZone || this.getTimeZone() })
      let newDate = this.formatDateTime(serverdate);
      return moment(new Date(newDate)).format("YYYY-MM-DD HH:mm:ss");
    },

    handleMonthDateTime(dateVal, time = "", conversion = false) {
      if (dateVal != "" && typeof dateVal != 'undefined') {
        var val = this.convertUTCDateToLocalDate(dateVal);
        const name = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const date = new Date(val);
        var str =
          name[date.getMonth()] +
          " " +
          ("0" + date.getDate()).slice(-2) +
          ", " +
          date.getFullYear();
        if (time != "") str += " " + this.handleHour12(dateVal);
        return str;
      }
    },
    getFormattedDate (dateStr, dateTimeZone, dateFormat) {
      if (dateStr && dateTimeZone) {
        // Create a new Moment object with the date string and convert to the desired timezone
        // const dateObj = momentTimeZone.tz(dateStr, "YYYY-MM-DD HH:mm:ss", dateTimeZone);
        // // Format the date object using the desired format string
        // return dateObj.format("MMM DD, YYYY (ddd)"); MMM DD, YYYY (ddd)
        moment.tz.setDefault(dateTimeZone)
        return moment(dateStr).tz(this.getTimeZone()).format(dateFormat)
      } else {
        moment.tz.setDefault('UTC')
        return moment(dateStr).tz(this.getTimeZone()).format(dateFormat)
      }
    },
    handleHour24(dateVal) {
      if (dateVal != "" && typeof dateVal != 'undefined') {
        var val = this.convertUTCDateToLocalDate(dateVal);
        return new Date(val).toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: false,
        });
      }
    },

    handleHour12(dateVal) {
      if (dateVal != "" && typeof dateVal != 'undefined') {
        var val = this.convertUTCDateToLocalDate(dateVal);
        return new Date(val).toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
      }
    },

    handleWeekName(dateVal) {
      if (dateVal != "" && typeof dateVal != 'undefined') {
        var val = this.convertUTCDateToLocalDate(dateVal);
        var weekName = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        return weekName[new Date(val).getDay()];
      }
    },

    handleWeekNameShorthand(dateVal) {
      if (dateVal != "" && typeof dateVal != 'undefined') {
        var val = this.convertUTCDateToLocalDate(dateVal);
        var weekName = [
          "Sun",
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
        ];
        return weekName[new Date(val).getDay()];
      }
    },

    handleDays(date) {
      var days = moment().diff(date, 'days');
      return days;
    },

    dateFormat(dateVal) {
      if (dateVal != "" && typeof dateVal != 'undefined') {
        var val = this.convertUTCDateToLocalDate(dateVal);
        const name = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        const date = new Date(val);
        const str =
          name[date.getMonth()] +
          " " +
          ("0" + date.getDate()).slice(-2) +
          ", " +
          date.getFullYear();
        return str;
      }
    },

    tConvert(time) {
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(''); // return adjusted time or original string
    },

    intToFloat(num, val) {
      let floatVal = num ? parseFloat(num) : 0;
      var fixedVal = val ? val : 1
      // Number(floatVal).toFixed(fixedVal);
      return floatVal && floatVal.toFixed(fixedVal);
    },

    trimWeek(week) {
      return week && week.slice(0, 3);
    },

    handleProfileDob(date) {
      var time = Date.now() - new Date(date).getTime();
      return Math.abs(new Date(time).getUTCFullYear() - 1970);
    },

    handleCreatedAt(date) {
      date = this.formatDateTime(date);
      const hours = Math.abs(new Date() - new Date(date)) / 36e5;
      var str = ''
      if (Math.round(hours) > 23) {
        str = Math.round(hours / 24) + " days ago";
      } else {
        str = Math.round(hours) + " hours ago";
      }
      return str;
    },

    formatDateTime(dateTime, format = "MMM D, YYYY h:mm A") {
      return dateTime ? moment(new Date(dateTime)).format(format) : "";
    },

    // compareDate(date) {
    //   date = this.formatDateTime(date);
    //   if (
    //     new Date(date).getFullYear() === new Date().getFullYear() &&
    //     new Date(date).getMonth() === new Date().getMonth() &&
    //     new Date(date).getDate() === new Date().getDate()
    //   ) {
    //     return "Today";
    //   } else {
    //     return this.dateFormat(date);
    //   }
    // },

    defaultCircleImage(e) {
      e.target.src =
        window.config.VUE_APP_BASE_URL +
        "assets/images/default/default_profile.png";
    },

    defaultImage(e) {
      e.target.src =
        window.config.VUE_APP_BASE_URL +
        "assets/images/default/default_profile_banner.png";
    },

    defaultBannerImage(e) {
      e.target.src =
        window.config.VUE_APP_BASE_URL +
        "assets/images/default/default_cat_banner.png";
    },

    baseUrlSrc(str) {
      if (str === null) {
        return ''
      } else {
        return str;
      }
    },

    // getCheckedArr(name) {
    //   var array = [];
    //   var checked = document.querySelectorAll(
    //     "input[name=" + name + "]:checked"
    //   );
    //   for (var i = 0; i < checked.length; i++) {
    //     array.push(checked[i].value);
    //   }
    //   return array;
    // },

    handleNotificationPermission() {
      if ("Notification" in window) {
        var curPermission = Notification.permission;
        // if (curPermission == "granted") {
        //   console.log("notifications allowed, go wild");
        // } else 
        if (curPermission == "prompt") {
          console.log("Promopting for permissions");
          // we can ask the user
          Notification.requestPermission();
        } else if (curPermission == "denied") {
          console.log("Permissions Denied for push notifications!");
        }
      } else {
        // Push notifiction API not supported
        console.log("Browser doesnt support for push notifications!");
      }
    },

    getToken() {
      return Cookies.get("token");
    },

    getUser(details) {
      var str = details ? details : 'user'
      return JSON.parse(localStorage.getItem(str));
    },

    handleProfileUrl(url) {
      if (url.slice(0, 4) == "http") {
        return url;
      } else {
        return "https://" + url;
      }
    },

    // verifyLoggedIn() {
    //   let token = this.getToken();
    //   let user = this.getUser()
    //   if (token) {
    //     if (user && user.user_type == 1) {
    //       this.$router.push({
    //         name: "Newhome",
    //       });
    //     } else if (user && user.user_type == 2) {
    //       this.$router.push({
    //         name: "dashboard",
    //       });
    //     } else if (user && user.user_type == this.ADMIN) {
    //       this.$router.push({
    //         name: "admindashboard",
    //       });
    //     }
    //     else {
    //       // console.log('else')
    //     }
    //   }
    // },

    getTimeZone() {
      // if user is available returns the timezone set in profile else local browser's timezone
      let userTimeZone = this.getUserTimeZone();
      if(userTimeZone) {
        return userTimeZone;
      } else {
        return this.getBrowserTimeZone();
      }
    },
    getUserTimeZone () {
      let userInfo = this.getUser()
      return userInfo && userInfo.timezone
    },
    getBrowserTimeZone () {
      let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (timeZone == 'Asia/Calcutta') {
        timeZone = 'Asia/Kolkata'
      }
      return timeZone
    },
    // checkUrl(url) {
    //   return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(
    //     url
    //   );
    // },

    minToHourMin(num) {
      var hr = (num / 60);
      var newhr = Math.floor(hr);
      var mins = (hr - newhr) * 60;
      var newmins = Math.round(mins);
      // return `${newhr}hr ${newmins}mins`;
      return [newhr, newmins]
    },

    // strReplace(str) {
    //   return str.replace("trainer", "user");
    // },

    getRouterHref(name) {
      const resolved = this.$router.resolve({
        name: name,
        params: { id: this.$route.params.id },
      });

      return window.location.origin + resolved.href
    },

    getParamsId(obj) {
      if (obj.entity_type == this.COURSE) {
        return obj.course_id;
      } else {
        return obj.session_id;
      }
    },

    getRouterName(obj) {
      if (obj.entity_type == this.COURSE) {
        return this.USERCOURSEDETAILS;
      } else {
        return this.USERSESSIONDETAILS;
      }
    },

    findObjById(arr, id) {
      var newObj = arr && arr.find(
        (obj) => obj.id === id
      );
      return newObj;
    },

    getExpectationValue(id) {
      var arr = ['', 'did not meet', 'somewhat met', 'met', 'exceeded']
      return arr[id]
    },

    getUserReviewRatingValue(id) {
      var arr = ['', 'Bad', 'OK', 'Good', 'Great', 'Excellent']
      return arr[id]
    },

    hasValue(json, findValue) {
      const hasValue = Object.values(json).includes(findValue);
      return hasValue
    },

    hasValueDeep(json, findValue) {
      const values = Object.values(json);
      let hasValue = values.includes(findValue);
      values.forEach(function (value) {
        if (typeof value === "object") {
          hasValue = hasValue || hasValueDeep(value, findValue);
        }
      })
      return hasValue;
    },

    getOS() {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
      } else if (/Android/.test(userAgent)) {
        os = 'Android';
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
      }

      return os;
    },
    isDesktop () {
      return window.innerWidth > 1020
    },
    assignSearchCategory(filter) {
      var arr = [
        "yoga",
        "aerobics",
        "meditation",
        "fitness",
        "zumba",
        "resistance",
        "Calisthenics",
        "spin",
        "strength",
        "cardio",
        "hiit",
        "stretching",
        "balance",
      ];
      var val = arr.indexOf(filter.toLowerCase());
      return (val + 1).toString();
    },
    getBrowserName() {
      let userAgentString = navigator.userAgent
      // Detect Chrome
      let chromeAgent = userAgentString.indexOf('Chrome') > -1
      // Detect Internet Explorer
      let IExplorerAgent = userAgentString.indexOf('MSIE') > -1 || userAgentString.indexOf('rv:') > -1
      if (IExplorerAgent) {
        return 'internetExplorer'
      }
      // Detect Firefox
      let firefoxAgent = userAgentString.indexOf('Firefox') > -1
      if (firefoxAgent) {
        return 'firefox'
      }
      // Detect Safari
      let safariAgent = userAgentString.indexOf('Safari') > -1
      // Discard Safari since it also matches Chrome
      if ((chromeAgent && safariAgent) || (userAgentString.match(/CriOS/i))) {
        safariAgent = false
      }
      if (safariAgent) {
        return 'safari'
      }
      // Detect Opera
      let operaAgent = userAgentString.indexOf('OP') > -1
      // Discard Chrome since it also matches Opera
      if ((chromeAgent) && (operaAgent)) {
        return 'opera'
      }
      return 'chrome'
      // var agent = window.navigator.userAgent.toLowerCase();
      // console.log(agent);
      // switch (agent) {
      //   case agent.indexOf("edge") > -1:
      //     return "MS Edge";
      //     break;
      //   case agent.indexOf("edg/") > -1:
      //     return false; // "Edge ( chromium based)"
      //     break;
      //   case agent.indexOf("opr") > -1 && !!window.opr:
      //     return "Opera";
      //     break;
      //   case agent.indexOf("chrome") > -1 && window.chrome:
      //     return false; // "Chrome"
      //     break;
      //   case agent.indexOf("trident") > -1:
      //     return "MS IE";
      //     break;
      //   case agent.indexOf("firefox") > -1:
      //     return "Mozilla Firefox";
      //     break;
      //   case agent.indexOf("safari") > -1:
      //     return "Safari";
      //     break;
      //   default:
      //     return "other";
      //     break;
      // }
    },

    handleLastLogin(date) {
      const dateObj = new Date(date);
      const locales = "en-us";
      const options = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      const dateString = dateObj.toLocaleDateString(locales, options);
      return dateString == "Invalid Date" ? "NA" : dateString;
    },
    async getBase64(file) {
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }
  },
});